<div class="row">
  <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 col-xxl-8">
    <div class="card m-b-0">
      <div class="card-header" style="padding: 15px 15px 9px 28px">
        <div style="display: flex; align-items: center">
          <img
            [src]="showlogo()"
            width="50px"
            class="m-r-10"
            style="padding-left: 0; border: solid #e3e3e3 1px"
          />
          <h4 *ngIf="lpProfile" class="m-0">
            <b>{{ "profile.details" | translate }} - </b>
            {{ lpProfile.companyName }}
          </h4>
        </div>
      </div>
      <div
        class="card-body align-items-center"
        style="min-height: 180px; padding: 0 15px 15px 28px"
      >
        <div class="text-center" *ngIf="forbidden">
          <h6 class="f-w-600">
            {{ "response.error.FORBIDDEN_RESPONSE" | translate }}
          </h6>
        </div>
        <div class="text-center" *ngIf="loadingProfile && !forbidden">
          <div class="loader-box">
            <div class="loader-34"></div>
          </div>
          <h6 class="f-w-600">{{ "fetching" | translate }}</h6>
        </div>
        <div class="pl-12 pr-20 grid-column" *ngIf="lpProfile$ | async">
          <div>
            <div style="display: flex; gap: 8px">
              <label class="col-form-label label f-w-600">
                {{ "profile.profileDetails.email" | translate }}:
              </label>
              <p class="col-form-label label">{{ lpProfile.email }}</p>
            </div>
            <div style="display: flex; gap: 8px">
              <label class="col-form-label label f-w-600">
                {{ "profile.profileDetails.fullName" | translate }}:
              </label>
              <p class="col-form-label label">
                {{ lpProfile.firstName + " " + lpProfile.lastName }}
              </p>
            </div>
            <div style="display: flex; gap: 8px">
              <label class="col-form-label label f-w-600">
                <b
                  >{{ "profile.profileDetails.companyAddress" | translate }}:</b
                >
              </label>
              <p class="col-form-label label">{{ lpProfile.companyAddress }}</p>
            </div>
          </div>

          <div>
            <div style="display: flex; gap: 8px">
              <label class="col-form-label label f-w-600">
                {{ "profile.profileDetails.tel" | translate }}:
              </label>
              <p class="col-form-label label">{{ lpProfile.phone }}</p>
            </div>
            <div style="display: flex; gap: 8px">
              <label class="col-form-label label f-w-600">
                {{ "profile.profileDetails.activity" | translate }}:
              </label>
              <p class="col-form-label label">
                {{ lpProfile.companyActivity }}
              </p>
            </div>
            <div style="display: flex; gap: 8px">
              <label class="col-form-label label f-w-600">
                {{ "profile.profileDetails.premiumEndDate" | translate }}:
              </label>
              <p class="col-form-label label">
                {{ premiumEndDate | localizedDate }}
              </p>
            </div>
          </div>
        </div>
        <div *ngIf="lpProfile">
          <label class="col-form-label label f-w-600 m-r-10">
            {{ "profile.profileDetails.categories" | translate }}:
          </label>
          <span
            *ngFor="let subCategory of lpProfile.subCategories"
            [ngClass]="'badge badge-light-blue'"
          >
            {{ subCategory }}
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-4">
    <div class="card pb-0 o-hidden earning-card">
      <div class="card-header earning-back"></div>
      <div class="card-body">
        <div class="earning-content">
          <img
            class="rounded-circle"
            src="assets/identity/consummers.svg"
            alt=""
          />
          <h5 class="f-w-600">
            {{ "welcomCard.statistic.titleCardStatistique" | translate }}
          </h5>
          <div *ngIf="loadingGlobalStatics$ | async; else loadingFalse">
            <div class="loader-box">
              <div class="loader-34"></div>
            </div>
          </div>
          <ng-template #loadingFalse>
            <h6>{{ resultGlobalStatistics.retainedConsumers | toKValue }}</h6>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="d-flex my-3 media-space-between">
  <h4 class="m-15">{{ "location.statistics.title" | translate }}</h4>
  <div class="d-flex mx-3">
    <app-refresh-button
      [state]="fetchingCardState"
      [date]="cachedAt"
      (buttonClick)="fetchCardsStatistics(true)"
    >
    </app-refresh-button>
  </div>
</div>
<div class="row">
  <div class="row p-r-0">
    <div
      class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-xxl-4 box-col-4 p-r-0"
    >
      <app-card
        [title]="impression.title"
        [icon]="impression.icon"
        [value]="impression.value"
        [class]="'eye'"
        [isLoading]="loadingGlobalStatics$ | async"
      >
      </app-card>
    </div>
    <div
      class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-xxl-4 box-col-4 p-r-0"
    >
      <app-card
        [title]="consumers.title"
        [icon]="consumers.icon"
        [value]="resultGlobalStatistics.uniqueConsumers"
        [class]="'eye'"
        [isLoading]="loadingGlobalStatics$ | async"
        [infoTooltip]="'infoTooltip.uniqueConsumers' | translate"
      >
      </app-card>
    </div>
    <div
      class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-xxl-4 box-col-4 p-r-0"
    >
      <app-card
        [title]="reach.title"
        [icon]="reach.icon"
        [value]="reach.value"
        [isLoading]="loadingGlobalStatics$ | async"
        [infoTooltip]="'infoTooltip.reach' | translate"
      >
      </app-card>
    </div>
  </div>
  <app-audience
    [inputAudience$]="inputAudience"
    [isPremium]="true"
    [startDate]="startDate"
    [endDate]="today"
  >
  </app-audience>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="media-space-between">
          <div class="d-flex m-t-15 align-items-center">
            <h4 class="m-0">
              {{ "location.statistics.retentionRate" | translate }}
            </h4>
            <app-info-tooltip-component
              style="padding-left: 4px"
              [infoTooltip]="'infoTooltip.retentionRate' | translate"
            ></app-info-tooltip-component>
          </div>
          <form
            [formGroup]="form"
            class="d-inline-flex col-10 col-xl-5 col-md-6 col-sm-8 col-xxl-4 justify-content-end"
          >
            <app-date-range-picker
              [form]="form"
              inputFormControlName="date"
            ></app-date-range-picker>
            <app-export
              class="m-l-10"
              [buttonName]="'export'"
              [data]="retentionChart"
              [title]="companyName"
            ></app-export>
            <app-refresh-button
              class="m-l-10"
              [state]="fetchingCardState"
              [date]="retentionRateCachedAt"
              (buttonClick)="fetchRetentionRate(true)"
            ></app-refresh-button>
          </form>
        </div>
        <div class="d-flex mx-15" style="justify-content: end"></div>
        <div class="card-body" id="retentionCHart">
          <app-column-chart
            [xaxisTitle]="columnChart.xaxisTitle"
            [yaxisTitle]="columnChart.yaxisTitle"
            [xaxisTitle]="columnChart.xaxisTitle"
            [resultRetentionRate]="retentionRate"
            [isLoading]="loadingRetentionRate$ | async"
            (loadingStateChanged)="handleRetentionLoadingStateChange($event)"
          ></app-column-chart>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="roleName === roleEnum.ROLE_FRANCHISE">
    <div class="row p-l-25">
      <div class="card">
        <div class="card-body">
          <div class="media-space-between">
            <h4 class="m-t-15">
              {{ "inseights.details.geographicData" | translate }}
            </h4>
          </div>
          <div class="card-locations mt-4">
            <app-map [companyName]="companyName"></app-map>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-technical-data [search]="search" [isPremium]="true"></app-technical-data>
</div>
